import { createBrowserRouter } from "react-router-dom";
import {
  MerchantAuthorization,
  UserList,
  Login,
  Dashboard,
  UserAdd,
  MerchantList,
  MerchantTaxNumber,
  MerchantAdd,
  BankAdd,
  BankList,
  BankCommissionList,
  BankAddCommission,
  BankAddCommissionProfile,
  SettingsMenu,
  SettingsRole,
  SettingsMessage,
  SettingsRoleMenu,
  BankRedirectList,
  BankRedirectAdd,
  PaymentAndTransaction,
  CampaignList,
  CampaignAdd,
  PreAuthAdd,
  PreAuthSalesAdd,
  SettingsParameter,
  SettingsNonsecure,
  PaymentWithLinked,
  PaymentWithLinkedList,
  BusinessBankListing,
  MerchantEndOfDay,
  BankPayment,
  BankCommissionProfileList,
  DocumentAdd,
  BankAddBulkCommissionUpload,
  MerchantExclusiveReport,
  MasterPassList,
  MasterPassAddPage,
  TransactionApproval,
  WorkplaceEntitlementManualEntryPage,
  SettingsServiceManagement,
  SettingsConfirmationParameters,
  NotFoundPage,
  CardBinAddBulkUpload,
  BinQueryPage,
  MerchantBankAdd,
  MerchantCommissionsByBank,
  MerchantSoftPOSAuthorization,
  MerchantTotalTransactionsReport,
  MerchantLimit,
  MerchantFinancialDocuments,
  DailyAccountHistory,
  SectorManagement,
  SectorInstallmentMappingManagement,
  MerchantAccountComponent,
  MerchantEndOfDayWithBalance,
  AnnulmentQueriesList,
  CurrentBalanceList,
  MerchantEndOfDayWithBalanceByDate,
  BankRedirectAddBulkUpload,
  MerchantMonthlyTransactionAmount,
  MerchantPOSUsageFee,
  MerchantValueDatedTransactions,
  MerchantValueDatedTransactionDetails,
  MerchantGoldBinding,
  MerchantBankAuthorization,
  PendingPayments,
  MerchantSettlementPage,
  ResourceManagement,
  TerminalDevicePage,
  ProductsPage,
  ProductGroupsPage,
  TaxRatesPage,
  EditTaxRatePage,
  AddTaxRatePage,
  AddProductWithExcelPage,
  ComponentGallery,
  ProductFormPage,
  FTPFiles,
  MerchantTodebPage,
  MerchantBlacklistHistoryPage,
  IPControlPage,
  MerchantIBANList,
  Enerya,
  InternalTools,
  SalesmanBonusesPage,
  SalesmanMonthlyDataPage,
  SalesmanDashboardPage,
  GMUSoftPosControlPage
} from "../pages";





export const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/merchant-management/merchant-account",
    element: <MerchantAccountComponent />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/user-management/user-listing",
    element: <UserList />,
  },
  {
    path: "/user-management/user-identification",
    element: <UserAdd />,
  },
  {
    path: "/merchant-management/merchant-listing",
    element: <MerchantList />,
  },
  {
    path: "/merchant-management/merchant-blacklist-history",
    element: <MerchantBlacklistHistoryPage />,
  },
  {
    path: "/merchant-management/merchant-taxNumber-listing",
    element: <MerchantTaxNumber />,
  },
  {
    path: "/vuk-507/terminal-device-page",
    element: <TerminalDevicePage />,
  },
  {
    path: "/merchant-management/merchant-identification",
    element: <MerchantAdd />,
  },
  {
    path: "/merchant-management/merchant-todeb",
    element: <MerchantTodebPage />,
  },
  {
    path: "/merchant-management/document-add",
    element: <DocumentAdd />,
  },
  {
    path: "/merchant-management/soft-pos-authorization",
    element: <MerchantSoftPOSAuthorization />,
  },
  {
    path: "/merchant-management/merchant-bankdefinition",
    element: <MerchantAuthorization />,
  },
  {
    path: "/vpos-management/vpos-banklisting",
    element: <BankList />,
  },
  {
    path: "/vpos-management/vpos-bankdefinition",
    element: <BankAdd />,
  },
  {
    path: "/vpos-management/merchant-vpos-bankdefinition",
    element: <MerchantBankAdd />,
  },
  {
    path: "/vpos-management/banklisting",
    element: <BankRedirectList />,
  },
  {
    path: "/vpos-management/vpos-bankrouting",
    element: <BankRedirectAdd />,
  },
  {
    path: "/vpos-management/merchant-bank-authorization",
    element: <MerchantBankAuthorization />,
  },
  {
    path: "/commission-management/commission-listing",
    element: <BankCommissionList />,
  },
  {
    path: "/commission-management/commission-alldefination",
    element: <BankAddBulkCommissionUpload />,
  },
  {
    path: "/vpos-management/vpos-merchantbanklisting",
    element: <BusinessBankListing />,
  },
  {
    path: "/commission-management/commission-definition",
    element: <BankAddCommission />,
  },
  {
    path: "/commission-management/commission-codedefinition",
    element: <BankCommissionProfileList />,
  },
  {
    path: "/commission-management/commission-codedefinition-detail",
    element: <BankAddCommissionProfile />,
  },
  {
    path: "/commission-management/sector-management",
    element: <SectorManagement />,
  },
  {
    path: "/commission-management/sector-commission-management",
    element: <SectorInstallmentMappingManagement />,
  },
  {
    path: "/merchant-management/masterpass-identification",
    element: <MasterPassList />,
  },
  {
    path: "/merchant-management/masterpass-identification-detail",
    element: <MasterPassAddPage />,
  },
  {
    path: "/setting-management/setting-menu",
    element: <SettingsMenu />,
  },
  {
    path: "/setting-management/setting-rol",
    element: <SettingsRole />,
  },
  {
    path: "/setting-management/setting-rolmenu",
    element: <SettingsRoleMenu />,
  },
  {
    path: "/setting-management/service-list",
    element: <SettingsServiceManagement />,
  },
  {
    path: "/setting-management/setting-source",
    element: <SettingsMessage />,
  },
  {
    path: "/setting-management/setting-parameter",
    element: <SettingsParameter />,
  },
  {
    path: "/setting-management/setting-nonsecure",
    element: <SettingsNonsecure />,
  },
  {
    path: "/setting-management/setting-definition-change-param",
    element: <SettingsConfirmationParameters />,
  },
  {
    path: "/setting-management/resource-management",
    element: <ResourceManagement />,
  },
  {
    path: "/campaign-management/campaign-listing",
    element: <CampaignList />,
  },
  {
    path: "/campaign-management/campaign-definition",
    element: <CampaignAdd />,
  },
  {
    path: "/manuel-transactions/manuel-preauth",
    element: <PreAuthAdd />,
  },
  {
    path: "/manuel-transactions/manuel-auth",
    element: <PreAuthSalesAdd />,
  },
  {
    path: "/reporting/payment-reporting",
    element: <PaymentAndTransaction />,
  },
  {
    path: "/reporting/daily-account-history",
    element: <DailyAccountHistory />,
  },
  {
    path: "/reporting/merchant-payment-reporting",
    element: <MerchantExclusiveReport />,
  },
  {
    path: "/reporting/merchant-payment",
    element: <MerchantEndOfDay />,
  },
  {
    path: "/reporting/salesman-bonuses",
    element: <SalesmanBonusesPage />,
  },
  {
    path: "/reporting/salesman-monthly-data",
    element: <SalesmanMonthlyDataPage />,
  },
  {
    path: "/reporting/salesman-dashboard",
    element: <SalesmanDashboardPage />,
  },
  {
    path: "/reporting/merchant-payment-with-balance",
    element: <MerchantEndOfDayWithBalance />,
  },
  {
    path: "/reporting/merchant-unmatch-reporting",
    element: <WorkplaceEntitlementManualEntryPage />,
  },
  {
    path: "/reporting/bank-payment",
    element: <BankPayment />,
  },
  {
    path: "/reporting/merchant-commissions-by-bank",
    element: <MerchantCommissionsByBank />,
  },
  {
    path: "/reporting/merchant-financial-documents",
    element: <MerchantFinancialDocuments />,
  },
  {
    path: "/reporting/merchant-total-transactions",
    element: <MerchantTotalTransactionsReport />,
  },
  {
    path: "/manuel-transactions/link-payment",
    element: <PaymentWithLinked />,
  },
  {
    path: "/manuel-transactions/link-listing",
    element: <PaymentWithLinkedList />,
  },

  {
    path: "/user-management/sent-approval-list",
    element: <TransactionApproval />,
  },
  {
    path: "/card-bin/add-bulk",
    element: <CardBinAddBulkUpload />,
  },
  {
    path: "/merchant-management/merchant-limits",
    element: <MerchantLimit />,
  },
  {
    path: "/merchant-management/annulment-queries",
    element: <AnnulmentQueriesList />,
  },
  {
    path: "/reporting/current-balance-list",
    element: <CurrentBalanceList />,
  },
  {
    path: "/reporting/merchant-payment-with-balance-by-date",
    element: <MerchantEndOfDayWithBalanceByDate />,
  },
  {
    path: "/reporting/merchant-pos-usage-fee",
    element: <MerchantPOSUsageFee />
  },
  {
    path: "/vpos-management/vpos-multi-bankrouting",
    element: <BankRedirectAddBulkUpload />
  },
  {
    path: "/reporting/merchant-monthly-transaction-amount",
    element: <MerchantMonthlyTransactionAmount />
  },
  {
    path: "/reporting/merchant-value-dated-transactions",
    element: <MerchantValueDatedTransactions />
  },
  {
    path: "/reporting/merchant-value-dated-transaction-details",
    element: <MerchantValueDatedTransactionDetails />
  },
  {
    path: "/reporting/gold-binding",
    element: <MerchantGoldBinding />
  },
  {
    path: "/reporting/pending-payments-list",
    element: <PendingPayments />,
  },
  {
    path: "/vuk-507/products",
    element: <ProductsPage />,
  },
  {
    path: "/product/add",
    element: <ProductFormPage />,
  },
  {
    path: "/product/:id",
    element: <ProductFormPage />,
  },
  {
    path: "/vuk-507/product-groups",
    element: <ProductGroupsPage />,
  },
  {
    path: "/vuk-507/tax-rates-listing",
    element: <TaxRatesPage />,
  },
  {
    path: "/edit-tax-rate",
    element: <EditTaxRatePage />,
  },
  {
    path: "/add-tax-rate",
    element: <AddTaxRatePage />,
  },
  {
    path: "/vuk-507/add-products-with-excel",
    element: <AddProductWithExcelPage />,
  },
  {
    path: "/developer/app-component-gallery",
    element: <ComponentGallery />,
  },
  {
    path: "/reporting/merchant-settlements",
    element: <MerchantSettlementPage />,
  },
  {
    path: "/reporting/ftp-files",
    element: <FTPFiles />,
  },
  {
    path: "/fraud-management/ip-control",
    element: <IPControlPage />,
  },
  {
    path: "/merchant-management/iban-list",
    element: <MerchantIBANList />,
  },
  {
    path: "/reconciliation/enerya",
    element: <Enerya />,
  },
  {
    path: "/internal-tools",
    element: <InternalTools />,
  },
  {
    path: "/internal-tools/bin-query",
    element: <BinQueryPage />,
  },
  {
    path: "/reporting/salesman-bonuses",
    element: <SalesmanBonusesPage />,
  },
  {
    path: "/vuk-507/gmu-control",
    element: <GMUSoftPosControlPage />,
  }
]);
